import React from 'react';
import Toggle from 'material-ui/Toggle';
import { Index } from 'react-instantsearch/dom';

const MEDIA = "TraditionalMediaCollective";
const INFLUENCER = "NewMediaCollective";

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: 10,
    width: '98%',
    margin: '0 auto',
    boxSizing: 'border-box',
    backgroundColor: 'white',
  },
  label: {
    lineHeight: 2.5,
  }
}

const handleToggle = (refine, currentRefinement) => (e) => { 
  if (currentRefinement.indexOf(INFLUENCER) !== -1) {
    refine([MEDIA]);
  } else {
    refine([INFLUENCER]);
  }
}

const CollectiveTypeToggle = ({ title, refine, currentRefinement, items }) => (
  <span style={styles.root}>
    <span style={styles.label}>Influencer</span>
    <Toggle
      style={{ width: 'auto' }}
      toggled={currentRefinement.indexOf(MEDIA) !== -1}
      onClick={handleToggle(refine, currentRefinement)}
      onToggle={handleToggle}
    />
    <span style={styles.label}>Media</span>
  </span>
)

export default CollectiveTypeToggle


/** WEBPACK FOOTER **
 ** ./components/CollectiveTypeToggle.js
 **/